// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "style/" + chunkId + "." + "830be3493ae53019d9fd" + ".css";
};